import React, { ReactElement } from 'react';
import { AddressElement } from '@stripe/react-stripe-js';
import { StripeAddressElementChangeEvent } from '@stripe/stripe-js';
import { Form, Input } from 'antd';

import { Features, isFeatureEnabled } from '../../../../featureToggles/features';
import { GOOGLE_MAPS_API_KEY } from '../../../../config';

import styles from './address.module.scss';

const isPlgExternal3Env = isFeatureEnabled(Features.PlgExternal3);
const isBillingUserFacingEnabled = isFeatureEnabled(Features.BillingUserFacing);

export interface IAddressElement {
  firstName: StripeAddressElementChangeEvent['value']['firstName'];
  lastName: StripeAddressElementChangeEvent['value']['lastName'];
  address: StripeAddressElementChangeEvent['value']['address'];
  phone: StripeAddressElementChangeEvent['value']['phone'];
  email: string;
}

interface IAddressFormProps {
  initialValues: IAddressElement | null;
  // use for Features.PlgExternal3
  name?: string;
  onChange?: (event: StripeAddressElementChangeEvent) => void;
  // end of use for Features.PlgExternal3
}

const renderEmailField = () => {
  const emailText = isBillingUserFacingEnabled ? 'Email' : 'Billing email';
  return (
    <>
      <div className={styles.label}>{emailText}</div>
      <Form.Item
        className={styles.emailInputField}
        name="email"
        rules={[
          { type: 'email' },
          { required: true }
        ]}
      >
        <Input placeholder="email" />
      </Form.Item>
    </>
  );
};

const renderAccountField = (name: string) => {
  if (!isPlgExternal3Env) {
    return;
  }
  return <div className={styles.organizationField}>
    <Input value={name} tabIndex={-1} disabled />
  </div>;
};

export const Address = ({ initialValues, onChange, name }: IAddressFormProps): ReactElement => {
  const hasAddress = !!initialValues?.address;

  return (
    <>
      {renderEmailField()}
      <div className={styles.container}>
        <AddressElement
          onChange={onChange}
          options={{
            fields: {
              phone: 'always'
            },
            display: {
              name: 'organization'
            },
            validation: {
              phone: {
                required: 'never'
              }
            },
            mode: 'billing',
            autocomplete: {
              mode: 'google_maps_api',
              apiKey: GOOGLE_MAPS_API_KEY
            },
            defaultValues: {
              name,
              address: initialValues?.address,
              phone: hasAddress ? initialValues?.phone : undefined
            }
          }}
        />
        {renderAccountField(name ?? '')}
      </div>
    </>
  );
};
